import { type Languages, languages } from '../i18n.language-config';

const gbpFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const audFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

export const currencyFormatter = {
  gbp: gbpFormatter,
  usd: usdFormatter,
  aud: audFormatter,
};

type Options = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  placeholder?: string;
  currency?: string;
  /** `compact` writes `$252.2M` instead of `$252,191,927.32`, for headline figures and chart labels. */
  notation?: Intl.NumberFormatOptions['notation'];
};

const numberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const NO_DECIMAL_FORMAT = {
  minimumFractionDigits: 0,
};

const currencyFormatterByLanguage = {
  [languages['en-GB']]: gbpFormatter,
  [languages['en-US']]: usdFormatter,
  [languages['en-AU']]: audFormatter,
};

export const deriveCurrencyFormat = (
  language: Languages,
  input: number | string | undefined | null,
  options?: Options
) => {
  if (input == null || Number.isNaN(input)) {
    return options?.placeholder || '-';
  }

  const _options = { ...numberFormatOptions, ...options };
  const currencyFormatterOptions = (
    currencyFormatterByLanguage[
      language as keyof typeof currencyFormatterByLanguage
    ] || usdFormatter
  ).resolvedOptions();

  return new Intl.NumberFormat(language, {
    ...currencyFormatterOptions,
    ..._options,
  }).format(Number(input));
};
